import { render } from "./AdminLanguages.vue?vue&type=template&id=a9df99a0&scoped=true"
import script from "./AdminLanguages.vue?vue&type=script&lang=js"
export * from "./AdminLanguages.vue?vue&type=script&lang=js"

import "./AdminLanguages.vue?vue&type=style&index=0&id=a9df99a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9df99a0"]])

export default __exports__